import React from "react";
import DocumentMeta from "react-document-meta";

import logo from "../../assets/images/flour_logo.png";
import warning from "../../assets/icons/warning-icon.png";

const meta = {
  title: "Ordering Temporarily Unavailable",
  description: "Online ordering is temporarily unavailable.",
};

/**
 * Full-screen interstitial shown when ordering is turned off via the
 * REACT_APP_ORDERING_ENABLED feature flag. It replaces the entire app
 * (landing page included) so visitors are met with this notice first.
 */
const OrderingClosed = () => {
  return (
    <DocumentMeta {...meta}>
      <div style={styles.page}>
        <div style={styles.card}>
          <img src={logo} alt="Flour" style={styles.logo} />
          <img src={warning} alt="" style={styles.icon} />
          <h1 style={styles.heading}>We're not accepting orders right now</h1>
          <p style={styles.body}>
            Online ordering is temporarily unavailable while we make some
            improvements to serve you better. We appreciate your patience and
            look forward to welcoming you back very soon.
          </p>
          <p style={styles.subtle}>
            For urgent orders or assistance, please reach out to your sales
            representative.
          </p>
        </div>
      </div>
    </DocumentMeta>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    background: "linear-gradient(135deg, #f7f1ea 0%, #efe3d6 100%)",
    boxSizing: "border-box",
  },
  card: {
    maxWidth: 560,
    width: "100%",
    background: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 12px 40px rgba(119, 70, 37, 0.15)",
    padding: "48px 40px",
    textAlign: "center",
  },
  logo: {
    height: 64,
    width: "auto",
    marginBottom: 24,
  },
  icon: {
    width: 72,
    height: 72,
    display: "block",
    margin: "0 auto 20px",
  },
  heading: {
    color: "#774625",
    fontSize: 26,
    fontWeight: 700,
    margin: "0 0 16px",
    lineHeight: 1.3,
  },
  body: {
    color: "#4a4a4a",
    fontSize: 16,
    lineHeight: 1.6,
    margin: "0 0 16px",
  },
  subtle: {
    color: "#8a8a8a",
    fontSize: 14,
    lineHeight: 1.6,
    margin: 0,
  },
};

export default OrderingClosed;
